import DataSource from './data-sources';
import { cbcrReportId } from '../config/constants';

const CBCRDataSource = () => <DataSource templateId={cbcrReportId} />;
export default CBCRDataSource;